export { default as BannerView } from './BannerView';
